import { authInterceptor } from './auth.interceptor';
// import { cachingInterceptor } from './caching.interceptor';
import { chatBotAuthInterceptor } from './chat-bot-auth.interceptor';
import { odataInterceptor } from './odata.interceptor';
import { iframeAuthInterceptor } from './iframe-auth.interceptor';

export const globalHttpInterceptors = [
  authInterceptor,
  // cachingInterceptor,
  chatBotAuthInterceptor,
  odataInterceptor,
  iframeAuthInterceptor,
];
